import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Config from '../../../../../Config';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import PopUpWithAnimation from '../../../../Shared/PopUpWithAnimation/PopUpWithAnimation';
import OtpExtendedPopup from '../../../../Block/SelfcareExtendedOtpButtonBlock/PopUp/OtpExtendedPopup';
import { buildUrlAndOpenSameWindow } from '../../../../../utilities/StringHelpers/StringHelpers';
import { removeServiceAsync } from '../../../../Block/AddonsAndUpgradesBlock/AddonsAndUpgradesBlockAsyncThunk';
import { reportDWH } from '../../../../Block/AddonsAndUpgradesBlock/AddonsAndUpgradesBlockSlice';
import { internalPage } from '../../../../../Components/Page/SelfCarePage/Constant';
import { goToPage } from '../../../../../Components/Page/SelfCarePage/SelfCareSlice';
import defaultIcon from './images/star-icon.svg';
import {LogoHelper, LogoType} from 'app/utilities/LogoHelper/helper';
import PopupRemoveService from './partials/PopupRemoveService';
import PopupSuccess from './partials/PopupSuccess';
import PopupError from './partials/PopupError';

const ServiceDetailsPage = (props) => {
    const [isDisplayPopup, setIsDisplayPopup] = useState(false);
    const [removeServiceStatus, setRemoveServiceStatus] = useState('');
    const [isDisplayOtpPopup, setIsDisplayOtpPopup] = useState(false);
    const serviceIcon = LogoHelper.getLogo(LogoType.MainLogo);
    const isLoadingNewData = props.loginData.isOtpExtendedAuthenticated && props.isLoadingExtendedData;
    let description = '';

    if (props.worldType == 'cellular' || props.worldType == 'abroad') {
        description = props.selectedService.selfCareCmsDataCriteria?.description;
    }
    else {
        description = props.selectedService.selfCareCmsData?.description;
    }

    const serviceUrl = props.selectedService.selfCareCmsData?.linkToService ? props.selectedService.selfCareCmsData?.linkToService : props.selectedService.selfCareCmsDataCriteria?.linkToService;
    let buttonText = 'בחזרה לאיזור האישי';

    if (serviceUrl) {
        if (props.selectedService.selfCareCmsDataCriteria?.buttonText) {
            buttonText = props.selectedService.selfCareCmsDataCriteria?.buttonText;
        }
        if (props.selectedService.selfCareCmsData?.buttonText) {
            buttonText = props.selectedService.selfCareCmsData?.buttonText;
        }
    }


    useEffect(() => {
        if (isLoadingNewData) {
            setIsDisplayOtpPopup(false);
            setIsDisplayPopup(true);
        }
    }, [isLoadingNewData]);


    let popupView = null;
    switch (removeServiceStatus) {
        case '': popupView = <PopupRemoveService selectedService={props.selectedService} onServiceRemove={handleOnServiceRemove} onCencelClick={handleOnCencelClick} />; break;
        case 'success': popupView = <PopupSuccess onClose={handlePopupSuccessButtonClick} />; break;
        case 'error': popupView = <PopupError onOpenChat={handleOnOpenWhatsApp} onRetryToRemove={handleOnServiceRemove} isDisplayWhatsApp={!props.selectedService?.selfCareCmsData?.isHideWhatsApp} />; break;
    }

    return (
        <div className='service-details-page'>

            <div className='service-details'>

                <div className='back-wrapper'>
                    <a href='#' onClick={(e) => { handleOnBackClick(e) }} className='back-icon'></a>
                </div>

                <div className='service-icon'>
                    <Image src={serviceIcon} alt={props.selectedService.selfCareCmsData?.title} />
                </div>
                <div className='title'> {props.selectedService.selfCareCmsData?.title} </div>
                <div className='description' dangerouslySetInnerHTML={{ __html: description }}></div>

                <div className='button-wrapper'>
                    <BtnSubmit
                        isBusiness={false}
                        text={buttonText}
                        onclick={handleOnServiceDetailsClick}
                        formid='service-details'
                        isDisplayArrows={false}
                        isPopupFromBottomOnMobile={true}
                    />
                </div>

                {
                    props.selectedService.isCanBeDeleted &&
                    <div className='link-wrapper'>
                        <a href='#' onClick={(e) => { handleOnRemoveClick(e) }}>הסרה</a>
                    </div>
                }

            </div>


            <PopUpWithAnimation isShow={isDisplayPopup} onClose={handlePopupClose}>
                {popupView}
            </PopUpWithAnimation>


            <PopUpWithAnimation className='selfcareExtendedOtpPopUp' isShow={isDisplayOtpPopup} onClose={() => setIsDisplayOtpPopup(false)}>
                <OtpExtendedPopup setShowPopUp={setIsDisplayOtpPopup} showPopup={isDisplayOtpPopup} isRefetchData={false} />
            </PopUpWithAnimation>


        </div>
    );

    function handleOnBackClick(e) {
        e.preventDefault();
        window.history.back();
    }

    function handleOnServiceDetailsClick() {
        if (serviceUrl) {
            buildUrlAndOpenSameWindow(serviceUrl);
        }
        else {
            window.history.back();
        }
    }

    function handleOnRemoveClick(e) {
        e.preventDefault();

        if (props.loginData.isFullAuthenticated || props.loginData.isOtpExtendedAuthenticated || props.worldType == 'cellular' || props.worldType == 'abroad') {
            setIsDisplayPopup(true);
        }
        else {
            setIsDisplayOtpPopup(true);
        }
    }

    function handleOnCencelClick(e) {
        e.preventDefault();
        setIsDisplayPopup(false);
    }

    async function handleOnServiceRemove() {
        props.reportDWH({ actionType: 'Service Page', status: 'Ongoing', messageText: 'Cancel Button Clicked' });

        const res = await props.removeServiceAsync(props.selectedService);
        const isSuccess = res?.payload?.isSuccess;
        setRemoveServiceStatus(isSuccess ? 'success' : 'error');

        if (isSuccess) {
            props.reportDWH({ actionType: 'Service Cancellation', status: 'Completed', messageText: 'Success' });
        }
        else {
            props.reportDWH({ actionType: 'Service Cancellation', status: 'Error', messageText: 'General Error' });
        }
    }

    function handleOnOpenWhatsApp() {
        const whatsAppLink = `https://wa.me/${Config.whatsAppSelfCare}?force_isolation=true&text=`;
        let win = window.open(whatsAppLink, '_blank');
        win.focus();
    }


    function handlePopupClose() {
        setIsDisplayPopup(false);
        if (removeServiceStatus == 'success') {
            props.goToPage(internalPage.Main);
        }
    }


    function handlePopupSuccessButtonClick() {
        setIsDisplayPopup(false);
        props.goToPage(internalPage.Main);
    }


};

const mapStateToProps = (state) => {
    return {
        selectedService: state.selfcarePage.selectedService,
        isLoadingExtendedData: state.selfcarePage.isLoadingExtendedData,
        loginData: state.authentication.loginData,
        worldType: state.addonsAndUpgradesBlock.worldType,
    };
};

const mapDispatchToProps = {
    removeServiceAsync,
    goToPage,
    reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceDetailsPage);
